<template>
  <div
    data-test="graphics-settingsBorderRadius"
  >
    <label class="sidebar-form-label">Rounded corners</label>

    <div class="settings-row settings-row-xs">
      <div class="settings-col-3 settings-col-xs">
        <validation-field as="input"
          v-model.number="_topLeft"
          rules="required|numeric|min:0"
          type="number"
          name="borderTopLeftRadius"
          min="0"
          :class="{ 'is-invalid': validationErrors['borderTopLeftRadius'] }"
          data-test="graphics-settingsBorderRadius-setTopLeft"
          data-entity="graphics-settingsBorderRadius-setTopLeft"
        />
        <label class="sidebar-input-sub-label"
          ><span class="icon icon-rounded-corner-top-left text-normal"></span
        ></label>
      </div>
      <div class="settings-col-3 settings-col-xs">
        <validation-field as="input"
          v-model.number="_topRight"
          rules="required|numeric|min:0"
          type="number"
          name="borderTopRightRadius"
          min="0"
          :disabled="isBorderRadiusSynced"
          :class="{ 'is-invalid': validationErrors['borderTopRightRadius'] }"
          data-test="graphics-settingsBorderRadius-setTopRight"
          data-entity="graphics-settingsBorderRadius-setTopRight"
        />
        <label class="sidebar-input-sub-label"
          ><span class="icon icon-rounded-corner-top-right text-normal"></span
        ></label>
      </div>
      <div class="settings-col-3 settings-col-xs">
        <validation-field as="input"
          v-model.number="_bottomRight"
          rules="required|numeric|min:0"
          type="number"
          name="borderBottomRightRadius"
          min="0"
          :disabled="isBorderRadiusSynced"
          :class="{ 'is-invalid': validationErrors['borderBottomRightRadius'] }"
          data-test="graphics-settingsBorderRadius-setBottomRight"
          data-entity="graphics-settingsBorderRadius-setBottomRight"
        />
        <label class="sidebar-input-sub-label"
          ><span
            class="icon icon-rounded-corner-bottom-right text-normal"></span
        ></label>
      </div>
      <div class="settings-col-3 settings-col-xs">
        <validation-field as="input"
          v-model.number="_bottomLeft"
          rules="required|numeric|min:0"
          type="number"
          name="borderBottomLeftRadius"
          min="0"
          :disabled="isBorderRadiusSynced"
          :class="{ 'is-invalid': validationErrors['borderBottomLeftRadius'] }"
          data-test="graphics-settingsBorderRadius-setBottomLeft"
          data-entity="graphics-settingsBorderRadius-setBottomLeft"
        />
        <label class="sidebar-input-sub-label"
          ><span
            class="icon icon-rounded-corner-bottom-left text-normal"></span
        ></label>
      </div>

      <div class="settings-col-12 settings-col-xs">
        <label class="checkbox">
          Sync all corners
          <input
            v-model="isBorderRadiusSynced"
            type="checkbox"
            data-test="graphics-settingsBorderRadius-syncCorners"
            data-entity="graphics-settingsBorderRadius-syncCorners"
          />
          <div class="checkmark">
            <span class="checkmark-tick fa-solid fa-check"></span>
          </div>
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  emits: ['update:top-left', 'update:top-right', 'update:bottom-left', 'update:bottom-right'],
  name: 'BorderRadius',
  props: {
    topLeft: {
      required: true,
      type: Number,
    },
    topRight: {
      required: true,
      type: Number,
    },
    bottomLeft: {
      required: true,
      type: Number,
    },
    bottomRight: {
      required: true,
      type: Number,
    },
  },
  data() {
    return {
      created: false, // used to skip first run of watcher
      isBorderRadiusSynced: false,
    };
  },
  computed: {
    _topLeft: {
      get() {
        return this.topLeft;
      },
      set(v) {
        if (v !== '') {
          this.$emit('update:top-left', v);
          if (this.isBorderRadiusSynced) {
            this.syncBorderRadius(v);
          }
        }
      },
    },
    _topRight: {
      get() {
        return this.topRight;
      },
      set(v) {
        if (v !== '') this.$emit('update:top-right', v);
      },
    },
    _bottomLeft: {
      get() {
        return this.bottomLeft;
      },
      set(v) {
        if (v !== '') this.$emit('update:bottom-left', v);
      },
    },
    _bottomRight: {
      get() {
        return this.bottomRight;
      },
      set(v) {
        if (v !== '') this.$emit('update:bottom-right', v);
      },
    },
  },
  watch: {
    isBorderRadiusSynced(newValue) {
      if (newValue && this.created) {
        this.syncBorderRadius();
      }
    },
  },
  created() {
    if (
      this.topLeft === this.topRight
      && this.topLeft === this.bottomLeft
      && this.topLeft === this.bottomRight
    ) {
      this.isBorderRadiusSynced = true;
    }
    this.$nextTick(() => {
      this.created = true;
    });
  },
  methods: {
    syncBorderRadius(v = false) {
      const radius = (v || v === 0) ? v : this.topLeft;
      this._topRight = radius;
      this._bottomLeft = radius;
      this._bottomRight = radius;
    },
  },
};
</script>
